import * as React from 'react';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useDispatch, useSelector } from 'react-redux';
import { availabilityStatus } from '../actions/users';
import IconToolTip from '../common/IconToolTip';

const STATUS_CONFIG = {
    WORKING: { label: "Online", color: "text-green-600", bgColor: "bg-green-600" },
    AWAY: { label: "Away", color: "text-yellow-600", bgColor: "bg-yellow-600" },
    DAYEND: { label: "Ending Day", color: "text-red-600", bgColor: "bg-red-600" },
    LEAVE: { label: "Leave", color: "text-orange-600", bgColor: "bg-orange-600" }
};

export default function UserWorkingStatus() {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'status-popper' : undefined;

    const { user } = useSelector(state => state.auth.newLoggedUserData || {});
    const currentStatus = user?.working_status || 'WORKING';
    const userStatus = STATUS_CONFIG[currentStatus] || STATUS_CONFIG.WORKING;

    const [status, setStatus] = React.useState(userStatus);

    // Generate available status options based on current status
    const getAvailableStatuses = () => {
        const allStatuses = Object.values(STATUS_CONFIG);
        return allStatuses.filter(s => s.label !== status.label);
    };

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleStatusChange = (newStatus) => {
        setStatus(newStatus);
        handleClose();

        // Map status label to backend status code
        const statusMapping = {
            'Online': 'WORKING',
            'Away': 'AWAY',
            'Ending Day': 'DAYEND',
            'Leave': 'LEAVE_APPROVED'
        };

        const working_status = statusMapping[newStatus.label];
        const id = user?.id;

        if (id) {
            dispatch(availabilityStatus({ working_status, id, dates: [new Date().toISOString()] }));
        }
    };

    return (
        <div className="relative inline-block mr-2">

            <div
                className="flex items-center justify-center gap-1 bg-scogoeee hover:bg-gray-200 px-3 py-1 rounded-full transition-colors duration-200 cursor-pointer shadow-sm"
                aria-describedby={id}
                onClick={handleClick}
            >
                <span className={`${status.color} text-lg`}>●</span>
                <div className="text-gray-800 font-medium">{status.label}</div>
                <span className="material-icons-outlined text-gray-600 text-sm">
                    expand_more
                </span>
            </div>


            <Popper id={id} open={open} anchorEl={anchorEl} placement="bottom-end" className="z-50 pt-1">
                <ClickAwayListener onClickAway={handleClose}>
                    <Box className="shadow-xl rounded-md bg-white border border-gray-200 p-1 w-40 animate-fadeIn">
                        {getAvailableStatuses().map((item) => (
                            <div
                                key={item.label}
                                className={`cursor-pointer p-2 hover:bg-gray-50 rounded flex items-center gap-2 ${item.color} transition-colors duration-150`}
                                onClick={() => handleStatusChange(item)}
                            >
                                <span className="text-lg">●</span>
                                <span className="text-gray-800">{item.label}</span>
                            </div>
                        ))}
                    </Box>
                </ClickAwayListener>
            </Popper>
        </div>
    );
}
